// extracted by mini-css-extract-plugin
module.exports = {"whiteframe":"styles_whiteframe__clrXa","padding":"styles_padding__3wgm_"};